module.exports = __webpack_public_path__ + "img/2-web.916af173.jpg";